import { render, staticRenderFns } from "./FormSubmitButton.vue?vue&type=template&id=70165fd6&scoped=true&"
import script from "./FormSubmitButton.vue?vue&type=script&lang=js&"
export * from "./FormSubmitButton.vue?vue&type=script&lang=js&"
import style0 from "./FormSubmitButton.vue?vue&type=style&index=0&id=70165fd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70165fd6",
  null
  
)

export default component.exports